
exports.register = (module) ->
    module.service 'Core.Services.MapLayers.Manager', ['$injector', exports.Manager]


# MapLayers.Manager exists as a one stop injectable service
# to allow a controller access to many types of map layers.
# It does so by use of an internal registry to map layer types,
# mapping common names (such as 'Soils', 'Management Zones', etc)
# to known MapLayer services.
class exports.Manager
    constructor: (@injector) ->
        @registry = {}
        @register ['Soil', 'SoilsLayer'], 'Core.Services.MapLayers.Soil'
        @register ['ManagementZones', 'ManagementZonesLayer', 'IrrigationZonesLayer'],
            'Core.Services.MapLayers.ManagementZone'
        @register ['YieldMapLayer'], 'Core.Services.MapLayers.YieldMap'
        @register ['CombinedLayers'], 'Core.Services.MapLayers.CombinedLayers'
        @register ['PrescriptionMap'], 'Core.Services.MapLayers.PrescriptionMap'
        @register ['PopulationMap', 'Populations'], 'Core.Services.MapLayers.PopulationMap'
        @register ['Field', 'FieldBoundary'], 'Core.Services.MapLayers.Field'

    # Register a new service. Can be registered with
    # one or multiple aliases (`name` can be a string
    # or an array).
    #
    #   - name - string|array; name(s) to register as
    #     nicknames for this service
    #   - servicename - string; name of the angular service
    #     to retrieve when requesting for these names
    #
    register: (name, servicename) =>
        if not $.isArray(name)
            name = [name]

        for i in name
            cleanName = @_cleanName(i)
            @registry[cleanName] = servicename

    # Retrieves an service that matches the given name/alias
    # If no match is found, an exception is thrown
    #
    #   - name - string; name to search for service under
    #
    get: (name) =>
        cleanName = @_cleanName(name)
        if @registry[cleanName]?
            service = @injector.get(@registry[cleanName])
            if not service.new?
                throw Error("The '#{name}' (#{@registry[cleanName]}) service does not provide a 'new' method")

            return service.new()
        else
            throw new Error "Invalid service nickname, #{name}"

    # Cleans up names for storing / checking the registry. In order
    # to make it easier to search the registry of services, we reformat
    # the keys that matches are stored under. They are lower cased, with
    # dashes and underscores removed so that the following is true:
    #
    # My-Service
    # mY_sErViCe
    # m_yse-rvice
    # MYServicE
    #
    # and other permutations, can all be matched up to the same thing.
    # By using _cleanName() before storing the alias (in `register()`)
    # AND when looking them up (in `get()`), we can match disparately
    # formatted versions of the service alias.
    #
    #   - name - string; the name to clean
    #
    _cleanName: (name) ->
        name = name.toLowerCase()
        name = name.replace(/[-_ ]/g, '')
        return name
